import {getRouteApi} from "@tanstack/react-router";

export const offerNotesRouteApi = getRouteApi("/_app/sales/offers/$offerId/notes/");
